import React from 'react';
export function ProblemSection() {
  const problems = [{
    emoji: '😰',
    title: 'Épuisement Créatif',
    text: "Vous arrivez au studio fatigué(e) d'avoir passé des heures à chercher de nouvelles séquences sur YouTube ou Instagram."
  }, {
    emoji: '🍃',
    title: 'Manque de Structure',
    text: 'Vos cours manquent parfois de fluidité. Vous improvisez les transitions et vous craignez que vos élèves ne progressent pas assez.'
  }, {
    emoji: '📱',
    title: "Indigestion d'Information",
    text: 'Vous cherchez sur Google et trouvez des exercices contradictoires. Vous ne savez plus quelle structure est la plus efficace pour un cours de 55 minutes.'
  }, {
    emoji: '😩',
    title: 'Charge Mentale Massive',
    text: 'La gestion des clients, du studio et de la planification vous empêche de profiter de votre passion pour le Pilates.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-170">
      <div className="max-w-5xl mx-auto" data-id="element-171">
        <div className="text-center mb-12" data-id="element-172">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-173">
            Vous reconnaissez-vous ?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-5 tracking-tight" data-id="element-174">
            Vous aimez enseigner, mais la{' '}
            <span className="italic text-pilates-rose" data-id="element-175">préparation</span> vous
            prend tout votre temps libre ?
          </h2>
          <p className="text-lg text-pilates-slate max-w-2xl mx-auto" data-id="element-176">
            Si vous êtes instructeur de Pilates, vous connaissez sûrement l'une
            de ces situations :
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-177">
          {problems.map((p, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/20 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-178">
              <div className="text-4xl mb-3" data-id="element-179">{p.emoji}</div>
              <h3 className="font-display text-xl font-semibold text-pilates-dark mb-2" data-id="element-180">
                {p.title}
              </h3>
              <p className="text-pilates-slate leading-relaxed" data-id="element-181">{p.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}